/* TODO: Find an accessible way to do this */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import { formatTime, isAtLeastOneHour } from "~/utils/time"

import { useCurrentTime, useDuration } from "./state"

export const ProgressBar: React.FC<{
  player: HTMLAudioElement | null
}> = ({ player }) => {
  const [currentTime] = useCurrentTime()
  const [duration] = useDuration()

  const progressWidth = `${((100 / duration) * currentTime || 0).toFixed(1)}%`

  return (
    <div className="flex items-center space-x-1 px-4 pb-1 font-display text-sm md:space-x-2">
      <div className="min-w-[5ch]">
        {formatTime(currentTime, isAtLeastOneHour(duration))}
      </div>

      <div className="grow">
        <div
          className="relative h-2 cursor-pointer bg-primary-200 dark:bg-primary-600"
          onClick={(e) => {
            if (!player) return
            const position = (1 / window.innerWidth) * e.screenX

            player.currentTime = duration * position
          }}
        >
          <div
            className="absolute top-0 left-0 h-2 bg-primary-500 dark:bg-primary-400"
            style={{ width: progressWidth }}
          />
        </div>
      </div>
      <div className="min-w-[5ch] text-right">
        {duration ? formatTime(duration) : "--:--"}
      </div>
    </div>
  )
}
